import { Table } from "antd";
import { convertFromWei } from "../../../../../utils/convertNumber";
import { TableCustom } from "./styled";
import BlockTimestamp from "../../../../../utils/blockTimestamp";
import CountdownTimer from "../../../../../utils/countDown";
import { useContext, useEffect, useState } from "react";
import LoadingSpin from "../../../../../components/Common/Loading";
import { ContextProviderWrapper } from "../../../../../components/Context";

const { Column } = Table;

const LiveSchedule = ({ listSchedule, clickedId }: any) => {
  const { theme }: any = useContext(ContextProviderWrapper);
  const [isLoading, setIsLoading] = useState(false);
  const filteredSchedule = listSchedule.filter(
    (item: any) => Number(convertFromWei(item.amount, 18)) > 0
  );

  const headingData = [
    {
      name: "Amount",
      dataIndex: "amount",
      key: "amount",
      render: (amount: any) => <div>{convertFromWei(amount, 18)}</div>,
    },
    {
      name: "Stake date",
      dataIndex: "startStakeBlock",
      key: "startStakeBlock",
      render: (startStakeBlock: any) => (
        <div>
          <BlockTimestamp startStakeBlock={startStakeBlock} />
        </div>
      ),
    },
    {
      name: "Remaining date",
      dataIndex: "endStakeBlock",
      key: "endStakeBlock",
      render: (endStakeBlock: any) => (
        <div>
          <CountdownTimer lastStakingBlock={endStakeBlock} />
        </div>
      ),
    },
  ];

  useEffect(() => {
    if (clickedId) {
      setIsLoading(true);
      setTimeout(() => {
        setIsLoading(false);
      }, 1000);
    }
  }, [clickedId]);

  return (
    <TableCustom className={isLoading ? `loading ${theme}` : `${theme}`}>
      {isLoading ? (
        <LoadingSpin />
      ) : (
        <Table dataSource={filteredSchedule} pagination={{ pageSize: 5 }}>
          {headingData.map((item: any) => (
            <Column
              title={item.name}
              dataIndex={item.dataIndex}
              key={item.key}
              render={item.render}
            />
          ))}
        </Table>
      )}
    </TableCustom>
  );
};

export default LiveSchedule;
